import React from "react";
import { useHttpClient } from "../http-client";

export const useUnlockResponseStatisticsApi = () => {
  const httpClient = useHttpClient();

  const unlock = React.useCallback(async (): Promise<void> => {
    await httpClient.post("/classifier/response_statistics/unlock", {});
  }, [httpClient]);

  return unlock;
};
